<template>
  <WhiteModal useTopPortal bodyClass="checklist-delete-form-modal" @close="$emit('close')">
    <div
      class="delete-modal-text qrw-heading-md bold qrw-text-content-base-primary"
      v-html="$t('checklist_editor.delete_title')"
    ></div>
    <div class="delete-modal-text qrw-paragraph-lg qrw-text-content-base-secondary">
      {{ $t("checklist_editor.delete_subtitle") }}
    </div>

    <template #footer>
      <div class="footer-buttons">
        <BasePushButton @click="$emit('close')" size="md" variant="ghost" textColor="content-base-secondary" class="bold">
          {{ $t("checklist_editor.delete_cancel") }}
        </BasePushButton>

        <BasePushButton
          size="md"
          @click="$emit('confirm')"
          variant="fill"
          textColor="content-base-inverse-primary"
          bgColor="background-error-default"
        >
          {{ $t("checklist_editor.delete_confirm") }}
        </BasePushButton>
      </div>
    </template>
  </WhiteModal>
</template>

<script>
export default {};
</script>

<style>
.delete-modal-text .del {
    color: var(--qrw-content-error-primary) !important;
    margin: 0 5px;
}

.checklist-delete-form-modal {
    padding: 40px 24px !important;
    flex-direction: column !important;
    display: flex;
    row-gap: 12px !important;
}
</style>

<style scoped>
.footer-buttons {
  display: flex;
  justify-content: space-between;
  width: 100%;
}

.delete-modal-text {
    display: flex;
    justify-content: center;
    width: 100%;
}
</style>
